import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/api/client';

interface DashboardFilters {
  month?: string;
  year?: string;
  agency?: string;
}

export function useDashboardData(filters: DashboardFilters) {
  return useQuery({
    queryKey: ['dashboard', filters],
    queryFn: () => apiGet('/dashboard', filters as Record<string, string>),
  });
}

export function useMemberTemplate() {
  return useQuery({
    queryKey: ['member-template'],
    queryFn: () => apiGet<{ isDefined: boolean }>('/dashboard/member-template'),
  });
}
